import { render, staticRenderFns } from "./RequestDataTable.vue?vue&type=template&id=09042780&scoped=true"
import script from "./RequestDataTable.vue?vue&type=script&lang=js"
export * from "./RequestDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09042780",
  null
  
)

export default component.exports